import {
  GET_CONDITIONS,
  GET_CATEGORIES,
  GET_SUBSCRIPTIONS,
  DELIVERY_LIST,
  ADD_ONS,
  CREATE_ADD_ONS,
  DELETE_ADD_ONS,
  GET_REQ_STATUS,
  VOLUME_UNIT,
  TOGGLE_SUBSCRIBED,
} from '../actionTypes';

const initialState = {
  categories: [],
  isLoadingCategories: false,
  errorCategories: false,
  categoriesMessage: '',

  conditions: [],
  isLoadingConditions: false,
  errorConditions: false,
  conditionsMessage: '',

  subscriptions: [],
  isLoadingSubscriptions: false,
  errorSubscriptions: false,
  subscriptionsMessage: '',

  delivery: [],
  deliveryLoading: false,

  addOns: [],
  isLoadingAddOns: false,
  updatedAddons: false,
  deletedAddOns: false,

  requestStatus: [],

  isLoadingVolumeUnit: false,
  volumeUnit: [],

  subscribed: false,
  isLoadingSubscribed: false,
  errorSubscribed: false,
  subscribedMessage: '',
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${TOGGLE_SUBSCRIBED}_PENDING`:
      return {
        ...state,
        isLoadingSubscribed: true,
        errorSubscribed: false,
      };
    case `${TOGGLE_SUBSCRIBED}_REJECTED`:
      return {
        ...state,
        isLoadingSubscribed: false,
        subscribedMessage: payload?.response?.data?.data || payload?.response?.data?.message,
        errorSubscribed: true,
      };
    case `${TOGGLE_SUBSCRIBED}_FULFILLED`:
      return {
        ...state,
        isLoadingSubscribed: false,
        errorSubscribed: false,
        subscribedMessage: '',
        subscribed: payload.data.data,
      };
    case `${GET_CATEGORIES}_PENDING`:
      return {
        ...state,
        isLoadingCategories: true,
        errorCategories: false,
      };
    case `${GET_CATEGORIES}_REJECTED`:
      return {
        ...state,
        isLoadingCategories: false,
        categoriesMessage: payload?.response?.data?.data || payload?.response?.data?.message,
        errorCategories: true,
      };
    case `${GET_CATEGORIES}_FULFILLED`:
      return {
        ...state,
        isLoadingCategories: false,
        errorCategories: false,
        categoriesMessage: '',
        categories: payload.data.data,
      };
    case `${DELIVERY_LIST}_PENDING`:
      return {
        ...state,
        error: false,
        deliveryLoading: true,
      };
    case `${DELIVERY_LIST}_REJECTED`:
      return {
        ...state,
        deliveryLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${DELIVERY_LIST}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        deliveryLoading: false,
        delivery: payload.data?.data,
      };
    case `${ADD_ONS}_PENDING`:
      return {
        ...state,
        error: false,
        isLoadingAddOns: true,
      };
    case `${ADD_ONS}_REJECTED`:
      return {
        ...state,
        isLoadingAddOns: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${ADD_ONS}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        isLoadingAddOns: false,
        addOns: payload.data?.data?.data || [],
      };
    case `${VOLUME_UNIT}_PENDING`:
      return {
        ...state,
        error: false,
        isLoadingVolumeUnit: true,
      };
    case `${VOLUME_UNIT}_REJECTED`:
      return {
        ...state,
        isLoadingVolumeUnit: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${VOLUME_UNIT}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        isLoadingVolumeUnit: false,
        volumeUnit: payload.data?.data?.data || [],
      };
    case `${GET_REQ_STATUS}_PENDING`:
      return {
        ...state,
        error: false,
      };
    case `${GET_REQ_STATUS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_REQ_STATUS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        requestStatus: payload.data.data,
      };
    case `${CREATE_ADD_ONS}_PENDING`:
      return {
        ...state,
        error: false,
        isLoading: true,
        updatedAddons: false,
      };
    case `${CREATE_ADD_ONS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${CREATE_ADD_ONS}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: 'Successfully create new addon',
        isLoading: false,
        addOns: [...state.addOns, payload.data?.data],
        updatedAddons: true,
      };
    case `${DELETE_ADD_ONS}_PENDING`:
      return {
        ...state,
        error: false,
        isLoading: true,
        updatedAddons: false,
      };
    case `${DELETE_ADD_ONS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${DELETE_ADD_ONS}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: 'Successfully delete addon',
        isLoading: false,
        addOns: state.addOns.filter((addon) => addon.id !== payload.data?.data?.id),
        updatedAddons: true,
      };

    case `${GET_CONDITIONS}_PENDING`:
      return {
        ...state,
        isLoadingConditions: true,
        errorConditions: false,
      };
    case `${GET_CONDITIONS}_REJECTED`:
      return {
        ...state,
        isLoadingConditions: false,
        conditionsMessage: payload?.response?.data?.data || payload?.response?.data?.message,
        errorConditions: true,
      };
    case `${GET_CONDITIONS}_FULFILLED`:
      return {
        ...state,
        isLoadingConditions: false,
        errorConditions: false,
        conditionsMessage: '',
        conditions: payload.data.data,
      };

    case `${GET_SUBSCRIPTIONS}_PENDING`:
      return {
        ...state,
        isLoadingSubscriptions: true,
        errorSubscriptions: false,
      };
    case `${GET_SUBSCRIPTIONS}_REJECTED`:
      return {
        ...state,
        isLoadingSubscriptions: false,
        subscriptionsMessage: payload?.response?.data?.data || payload?.response?.data?.message,
        errorSubscriptions: true,
      };
    case `${GET_SUBSCRIPTIONS}_FULFILLED`:
      return {
        ...state,
        isLoadingSubscriptions: false,
        errorSubscriptions: false,
        subscriptionsMessage: '',
        subscriptions: payload.data.data,
      };

    default:
      return state;
  }
}
